import React from 'react'
import { makeStyles } from "@material-ui/core/styles"
import StyledDirectoryView from "../../../utils/StyledDirectoryView"
import { Button, Card, CardContent, CardHeader, Divider, Grid, IconButton, LinearProgress, Paper, Typography } from '@material-ui/core'
import PageviewIcon from '@material-ui/icons/Pageview'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow'
import { DIYActions } from '../../../actions'
import { Pagination } from '@material-ui/lab'

const useStyles = makeStyles((theme) => ({
    rootDesktop: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    rootTablet: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5),
    },
    rootMobile: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    dividerColor: {
        marginTop: 0,
        marginBottom: 10,
        backgroundColor: theme.palette.text.tertiary,
        marginLeft: '10px',
        marginRight: '10px'
    },
    globalactions: {
        position: 'relative',
        right: theme.spacing(1),
        top: theme.spacing(2),
    },
    card: {
        borderRadius: '10px',
        color: theme.palette.text.secondary,
        backgroundColor: "#252525",
    },
    coloredpaperFileList: {
        height: '72vh',
        color: theme.palette.text.secondary,
        backgroundColor: "#4d4d4d",
    },
    coloredpaperFileView: {
        height: '72vh',
        width: '100%',
        color: theme.palette.text.secondary,
        backgroundColor: "#4d4d4d",
    },
    coloredpaperTextFileView: {
        height: '66vh',
        width: '100%',
        marginBottom: "8px",
        color: theme.palette.text.secondary,
        backgroundColor: "#4d4d4d",
    },
}))

const FileExplorer = ({ responsive, ticket, closeReport, profile }) => {
    const classes = useStyles()
    const [fileData, setData] = React.useState(null)

    React.useEffect(() => {
        DIYActions.Reports.getReport({ workorder: ticket.data.Workorder, reporttype: ticket.reporttype }, setData)
    }, [])

    return (
        <Card className={responsive.isDesktopOrLaptop ? classes.rootDesktop : responsive.isTablet ? classes.rootTablet : responsive.isMobile ? classes.rootMobile : classes.rootDesktop}>
            <CardHeader style={{ paddingTop: 0, paddingBottom: 0 }}
                title={
                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={2}>
                        <Grid item><IconButton size='medium' color='secondary' onClick={() => closeReport()}><ArrowBackIcon /></IconButton></Grid>
                        <Grid item><Typography variant='h5' color='textSecondary'>{ticket.data.sitename} - {ticket.data.Workorder}</Typography></Grid>
                    </Grid>
                }
                disableTypography={true}
            />
            <Divider style={{ backgroundColor: "#4d4d4d", marginTop: '5px', marginBottom: '5px' }} />
            <CardContent style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 8, paddingRight: 8 }}>
                <iframe srcDoc={fileData} style={{ width: '100%', height: '72vh', border: 'none', background: '#FFFFFF' }} />
            </CardContent>
        </Card>
    )
}

export default FileExplorer
